import { useState, useEffect } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Stack,
    MenuItem,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { IRecall } from "../../../@types/recalls";

type Props = {
    open: boolean;
    recall: IRecall | null;
    onClose: VoidFunction;
    onSave: (data: Partial<IRecall>) => void;
};

export default function EditRecallDialog({ open, recall, onClose, onSave }: Props) {
    const [recallType, setRecallType] = useState("");
    const [communicationType, setCommunicationType] = useState<"SMS" | "Email" | "Phone Call">("SMS");
    const [recallDate, setRecallDate] = useState<Date | null>(null);
    const [message, setMessage] = useState("");

    useEffect(() => {
        if (recall) {
            setRecallType(recall.recallType || "");
            setCommunicationType(recall.communicationType || "SMS");
            setRecallDate(recall.recallDate ? new Date(recall.recallDate) : null);
            setMessage(recall.message || "");
        }
    }, [recall]);

    const handleSave = () => {
        const updatedData: Partial<IRecall> = {
            recallType,
            communicationType,
            scheduledDate: recallDate || undefined,
            message,
        };
        onSave(updatedData);
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Edit Recall</DialogTitle>
            <DialogContent>
                <Stack spacing={3} sx={{ mt: 2 }}>
                    <TextField
                        label="Recall Type"
                        value={recallType}
                        onChange={(e) => setRecallType(e.target.value)}
                        fullWidth
                    />

                    <TextField
                        select
                        label="Communication Type"
                        value={communicationType}
                        onChange={(e) => setCommunicationType(e.target.value as "SMS" | "Email" | "Phone Call")}
                        fullWidth
                    >
                        <MenuItem value="SMS">SMS</MenuItem>
                        <MenuItem value="Email">Email</MenuItem>
                        <MenuItem value="Phone Call">Phone Call</MenuItem>
                    </TextField>

                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                            label="Recall Date"
                            value={recallDate}
                            onChange={(newValue) => setRecallDate(newValue)}
                            slotProps={{ textField: { fullWidth: true } }}
                        />
                    </LocalizationProvider>

                    <TextField
                        label="Message"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        multiline
                        rows={4}
                        fullWidth
                    />
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button variant="contained" onClick={handleSave}>
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
}
